import * as React from 'react'

import { CredentialsFields } from 'main/gql/credentials'
import { GatheringFields } from 'main/gql/gathering/'
import { GatheringRegistrations_gatheringRegistrations } from 'main/gql/registration/'
import { UnreachableCaseError } from 'main/util/ts'
import { UpdateGatheringRegistration_updateGatheringRegistration } from './gql'
import Confirmation from './steps/Confirmation'
import Login from './steps/Login'
import Register from './steps/Register'
import SignUp from './steps/SignUp'
import Update from './steps/Update'
import { ITrackData, track } from './track'
import { IRegisterStep, IUpdateStep, Step, StepName } from './types'

interface IProps {
  gathering: GatheringFields
  schoolId: number
  step: Step | null
  trackData: ITrackData
  onChangeStep: (step: Step) => void
  onAuth: (credentials: CredentialsFields) => void
  onComplete?: () => void
  onRequestClose: () => void
}

export default function Content(props: IProps) {
  const { gathering, schoolId, step, trackData, onChangeStep, onComplete, onAuth, onRequestClose } =
    props

  if (!step) return null

  switch (step.__stepname) {
    case StepName.Login:
      return (
        <Login
          onRequestSignUp={() => onChangeStep({ __stepname: StepName.SignUp })}
          onComplete={credentials => {
            track('completed_login', trackData)
            handleAuth(credentials)
          }}
        />
      )

    case StepName.SignUp:
      return (
        <SignUp
          onRequestLogin={() => onChangeStep({ __stepname: StepName.Login })}
          onComplete={credentials => {
            track('completed_sign_up', trackData)
            handleAuth(credentials)
          }}
          schoolId={schoolId}
        />
      )

    case StepName.Update:
      return (
        <Update
          registration={step.registration}
          onComplete={registration => {
            track('completed_update_registration', trackData)
            handleConfirmation(registration, step)
          }}
        />
      )

    case StepName.Register:
      return (
        <Register
          gathering={step.gathering}
          onComplete={registration => {
            track('completed_registration', trackData)
            handleConfirmation(registration, step)
          }}
          user={step.user}
        />
      )

    case StepName.Confirmation:
      return (
        <Confirmation
          onComplete={() => {
            track('completed_confirmation', trackData)
            onRequestClose()
          }}
          user={step.user}
        />
      )

    default:
      throw new UnreachableCaseError(step)
  }

  function handleConfirmation(
    registration:
      | UpdateGatheringRegistration_updateGatheringRegistration
      | GatheringRegistrations_gatheringRegistrations,
    previousStep: IRegisterStep | IUpdateStep,
  ) {
    if (onComplete) {
      onComplete()
    }
    onChangeStep({
      __stepname: StepName.Confirmation,
      gathering,
      registration,
      user: previousStep.user,
    })
  }

  function handleAuth(credentials: CredentialsFields) {
    onAuth(credentials)
    onChangeStep({
      __stepname: StepName.Register,
      gathering,
      user: credentials.user,
    })
  }
}
